import { z } from "zod";
import {
  ObjectType
} from "./types";
const objectType = z.union([
  z.literal(ObjectType.Value),
  z.literal(ObjectType.Text),
  z.literal(ObjectType.Inline),
  z.literal(ObjectType.Block),
  z.literal(ObjectType.Document),
  z.literal(ObjectType.Leaf),
  z.literal(ObjectType.Selection),
  z.literal(ObjectType.Mark),
  z.literal(ObjectType.Range),
  z.literal(ObjectType.Decoration),
  z.literal(ObjectType.Annotation),
  z.literal(ObjectType.Point),
  z.literal(ObjectType.Operation),
  z.undefined()
]);
function any() {
  return z.any();
}
const valueJSON = z.object({
  object: objectType.optional(),
  document: any().optional(),
  selection: any().optional(),
  annotations: z.record(z.string(), any()).optional(),
  data: z.record(z.string(), z.any()).optional()
});
export {
  objectType,
  valueJSON
};
//# sourceMappingURL=schema.js.map